export default {
      id: "masterfiles-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#masterfiles",
      toString: function () {
        return this.url;
      }
    }